import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentoProcessoRoutingModule } from './documento-processo-routing.module';
import { NovoComponent } from './pages/novo/novo.component';
import { DetalheComponent } from './pages/detalhe/detalhe.component';
import { ListaComponent } from './pages/lista/lista.component';
import { ListaComponent as DocumentoListaComponent } from './lista/lista.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import { NovaPastaDocumentoComponent } from './components/nova-pasta-documento/nova-pasta-documento.component';
import {NgxPaginationModule} from "ngx-pagination";

@NgModule({
  declarations: [
    NovoComponent,
    DetalheComponent,
    ListaComponent,
    DocumentoListaComponent,
    NovaPastaDocumentoComponent
  ],
  exports: [
    NovoComponent,
    DocumentoListaComponent,
    NovaPastaDocumentoComponent
  ],
  imports: [
    CommonModule,
    DocumentoProcessoRoutingModule,
    ComponentesModule,
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPaginationModule
  ]
})
export class DocumentoProcessoModule { }
